<template>
    <ElDialog
        v-model="visible"
        :width="checkJpEnv() ? '920px' : '1220px'"
        :close-on-click-modal="false"
        :show-close="false"
        @close="handleClose"
        append-to-body
        class="pricing-dialog"
    >
        <template #header>
            <div class="flex items-center">
                <p class="flex-1 text-xl font-semibold  text-black text-center">{{ t('title.plansAndPricing') }}</p>
                <button
                    class="th-btn th-btn-plain th-btn-sm th-btn-only-icon"
                    @click="handleClose"
                >
                    <PtIcon :icon="iconSolidCloseBig" class="th-btn-icon w-6 h-6" />
                </button>
            </div>
            <div class="text-center mt-1">
                <p class="flex-1 text-sm text-gray-90 ">{{ t('subtitle.plansAndPricing') }}</p>
            </div>
        </template>
        <div style="padding-top: 12px;">
            <PlanListHome />
        </div>

        <template #footer>
            <!-- <div class="text-center cursor-pointer text-xs text-blue-500">
                View more details
            </div> -->
        </template>
    </ElDialog>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { ref, onMounted } from 'vue';
import { ElDialog } from 'element-plus';
import { PtIcon } from 'patsnap-biz';
import iconSolidCloseBig from '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import { PlanListHome, checkJpEnv } from '@eureka/shared/plg-plan';
import { cn, en, jp, tw } from '@eureka/shared/plg-plan/src/locales';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { EurekaTrackEventType } from '@eureka/domains/src/bi-track/types';

const props = defineProps<{
    onClose?: () => void;
}>();

const { t } = useI18n({
    messages: { cn, en, jp, tw },
});

const visible = ref(true);
const biTrackService = injectService<BiTrackService>(BiTrackService);

function handleClose() {
    visible.value = false;
    if (props.onClose) {
        props.onClose();
    }
}

onMounted(() => {
    // 埋点：升级页面打开
    biTrackService.biTrack(EurekaTrackEventType.SS_EUREKA_UPGRADE_PAGE, {
        sourceType: 'pricing_page_view',
        eventDetailStr: {
            product_line: 'eureka_ip',
        },
    });
});
</script>

<style lang="scss">
.pricing-dialog {
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    display: flex;
    flex-direction: column;

    @media (max-height: 800px) {
        max-height: 90vh;
    }

    .el-dialog__header {
        padding: 24px 24px 12px 24px !important;
        margin-right: 0;
        flex-shrink: 0;
    }

    .el-dialog__body {
        padding: 0 !important;
        display: flex;
        justify-content: center;
        overflow-y: auto;
        flex: 1;
        min-height: 0;
    }

    .el-dialog__footer {
        padding: 24px !important;
        flex-shrink: 0;
    }
}
</style>
